import { AlertTriangle, RefreshCw } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'

interface InlineErrorCardProps {
  title?: string
  message?: string
}

export function InlineErrorCard({
  title = 'Something went wrong',
  message = 'An unexpected error occurred. Please try again.',
}: InlineErrorCardProps) {
  const handleRetry = () => {
    window.location.reload()
  }

  return (
    <div className="flex items-center justify-center p-8" data-testid="inline-error-card">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="bg-destructive/10 mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full">
            <AlertTriangle className="text-destructive h-6 w-6" />
          </div>
          <CardTitle className="text-lg">{title}</CardTitle>
          <CardDescription>{message}</CardDescription>
        </CardHeader>
        <CardContent className="flex justify-center">
          <Button onClick={handleRetry} variant="outline" data-testid="inline-error-retry-button">
            <RefreshCw className="mr-2 h-4 w-4" />
            Try again
          </Button>
        </CardContent>
      </Card>
    </div>
  )
}
